import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { LayoutService } from '../layout.service';
import { SubscriptionBannerService } from 'src/app/services/subscription-banner.service';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-menu-layout',
  templateUrl: './menu-layout.component.html',
  styleUrls: ['./menu-layout.component.scss']
})
export class MenuLayoutComponent implements OnInit, AfterViewInit{
  @ViewChild('navbarlayout', { static: true, read: ElementRef }) navbar!: ElementRef;
  subscriptionBanners: any[] = [];
  currentUrl: string = '';

  constructor(public SubscriptionBannerService: SubscriptionBannerService, private router:Router){}

  ngOnInit(): void {
    this.currentUrl = this.router.url;
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: any) => {
      this.currentUrl = event.urlAfterRedirects || event.url || '';
    });

    this.SubscriptionBannerService.fetchSubscriptionBillingAlertsBanners();
    this.SubscriptionBannerService.subscriptionBannersObservable$.subscribe((data: any) => {
      this.subscriptionBanners = data.banners || [];
    }
    );
  }

  ngAfterViewInit() {
  }

  public closeBanner(banner: any): void {
    const idx = this.subscriptionBanners.indexOf(banner);
    if (idx > -1) {
      this.subscriptionBanners[idx].hide = true;
    }
    const newBannerData = {
      banners: this.subscriptionBanners,
      lastFetchedAt: new Date().toISOString()
    } 
    localStorage.setItem('SubscriptionBanners', JSON.stringify(newBannerData));
  }

  public gotoSubscriptionDetails(){
    this.router.navigate(['/profile/SubscriptionDetails'])
  }

  public shouldShowBanner(banner: any): boolean {
    const severity = banner?.Severity?.toLowerCase();

    // Red banners (danger) are shown everywhere
    if (severity === 'danger') {
      return true;
    }

    // Yellow banners (warning) are only shown on selected pages
    if (severity === 'warning') {
      const allowedPages = [
        '/dashboard',
        '/servicenear/dashboard',
        '/servicenear/serviceDetails',
        '/products'
      ];
      return allowedPages.some(page => this.currentUrl.includes(page));
    }

    return true;
  }

}
